// YOU HAVE TO RE-RERUN PROJECT TO RELOAD NEW VALIDATOR AFTER CHANGING THIS FILE
import { Validator } from "vee-validate";
import { isValidNationalRegister } from "./utils/korfine-person";

// Custom validator to check if a value is greater than zero
const greaterZeroValidator = {
  getMessage: (field) => `The ${field} should be greater than zero`,
  validate: (value) => value > 0,
};

Validator.extend("greater_zero", greaterZeroValidator);

// Custom validator to check if a user is at least 17 years and 6 months old
const over17And6MonthsValidator = {
  getMessage: () => 'You must be at least 17 years and 6 months old.',
  validate: (value) => {
    if (!value) {
      return false;
    }

    const inputDate = new Date(value);
    const today = new Date();
    
    // Calculate the date 17 years and 6 months ago from today
    const seventeenYearsAndSixMonthsAgo = new Date(
      today.getFullYear() - 17, 
      today.getMonth() - 6, 
      today.getDate()
    );

    return inputDate <= seventeenYearsAndSixMonthsAgo;
  },
};

Validator.extend('over_17_and_6_months', over17And6MonthsValidator);

// Custom validator to check if provide email or phone number
const emailOrPhoneNumber = {
  getMessage: () => 'You must provide email or phone number.',
  validate: (value) => {
    return !!value;
  },
};

Validator.extend('is_provide_email_or_phone', emailOrPhoneNumber);

// Optional national register: when filled, 11 digits (WinApp CodeHelper.IsNationalRegister).
// The message is an i18n key the validation summary translates (see validation-summary/customer-message).
Validator.extend('national_register', {
  getMessage: () => 'NATIONAL_REGISTER_NOT_VALID||',
  validate: (value) => isValidNationalRegister(value),
});


export default Validator;
